export const BLOGGERS_COLLABORATION =
  'https://docs.google.com/forms/d/e/1FAIpQLSd2x8J5pW8PjF2Te5rT-hlU5Xa5DIqEol46BA3M58AbXfa2tA/viewform';

export const CONSTANT_PROMOTION =
  'https://docs.google.com/forms/d/e/1FAIpQLSd2JqXrL7osObzsZtvSFSypvHq4Ui69VUcLZyEOL-CurUeWUg/viewform';
